<template>
    <BasePanel headline="lang_PUBLISHING_TRACKING_PANEL_CAPTION_MY_MAPPING">
        <template v-slot:panelContent>
            <BaseInlineEditingDataTable 
                context="MyMapping" :headers="headers" 
            >
                <template v-slot:topSlot>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="2">          
                            <BaseButton 
                                @click="addNewRow"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                            />      
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:editRow="{ items }">
                    <MyMappingEditRow :items="items"/>
                </template>
            </BaseInlineEditingDataTable>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseInlineEditingDataTable from '@/components/_base/BaseInlineEditingDataTable'
import BaseButton from '@/components/_buttons/BaseButton'
import MyMappingEditRow from './_buttons/MyMappingEditRow'

export default {
    name: "MyMappingPanel",
    components: { 
        BasePanel,
        BaseInlineEditingDataTable,
        BaseButton,
        MyMappingEditRow
    },
    computed: {        
        /** Returns an Array with my mapping header-objects with props.
         *  @return {[{text: String, align: string, value: string}]} props of the header */        
        headers() {
            return [
                {text: this.$t('lang_PUBLISHING_TRACKING_MAPPING_PRO_LISTS'), align: 'left', value: 'prolistsPhrase'},
                {text: this.$t('lang_PUBLISHING_TRACKING_MAPPING_MY_LISTS'), align: 'left', value: 'myPhrase'},
                {text: 'Art', align: 'right', value: 'art'}, // lang const
                {text: '', align: 'right', value: 'editInline', width: "50px"},
                {text: '', align: 'right', value: 'delete', width: "50px"}                
            ]
        },
        myMappingItems: {
            get() { return this.$store.getters.getMyMapping },
            set(items) { this.$store.commit('setMyMapping', items)}
        }
    },
    methods: {
        addNewRow(){
            this.$store.dispatch('addNewRowMyMapping')
        }
    }   
}
</script>